import React from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { router } from "@/components/App/router";
import { I18nextProvider } from "react-i18next";
import i18n from "@/i18n";
import ContainerLoader from "@/ui/ContainerLoader/ContainerLoader";

// Temporary, opt-in diagnostics for the owner's local Chrome. No production code.
if (import.meta.env.DEV) {
  void import("./dev/homeScrollDebug").then(({ installHomeScrollDebug }) => {
    installHomeScrollDebug();
  });
}

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Failed to find the root element");
const root = createRoot(rootElement);

root.render(
  <I18nextProvider i18n={i18n}>
    <RouterProvider
      router={router}
      fallbackElement={
        <div role="status" aria-label="Загружаем страницу">
          <ContainerLoader />
        </div>
      }
    />
  </I18nextProvider>
);
